import { render, staticRenderFns } from "./DashboardArticlesList.vue?vue&type=template&id=9ce27750&scoped=true"
import script from "./DashboardArticlesList.vue?vue&type=script&lang=js"
export * from "./DashboardArticlesList.vue?vue&type=script&lang=js"
import style0 from "./DashboardArticlesList.vue?vue&type=style&index=0&id=9ce27750&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce27750",
  null
  
)

export default component.exports